// First tab stop of the ERP shell: jumps past the ~30 nav controls to the page.
// Focuses <main> directly instead of following #main, so the address bar keeps
// reading "/" and no history entry is added (D1).
export function SkipLink() {
  return (
    <a
      href="#main"
      onClick={(e) => {
        e.preventDefault();
        document.getElementById('main')?.focus();
      }}
      className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-2 focus:z-system rounded-md border border-primary bg-surface px-2 py-1 text-[0.75rem] font-medium text-primary-text shadow-sm"
    >
      Skip to main content
    </a>
  );
}
